import React, { Component } from 'react';

import { history } from '../../../state/store';

import AuthApi from '../../../api/auth';
import Button from '../../form/Button';
import Message from '../../form/Message';

class ChangePasswordForm extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            isbusy: false,
            errorMessage: null,
            pwlen: false,
            uppercase: false,
            lowercase: false,
            number: false,
            special: false,
        };

        this.onChange = this.onChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.validateForm = this.validateForm.bind(this);
    }

    onChange(evt) {
        let changes = {};
        changes[evt.target.name] = evt.target.value;
        this.setState(changes);
    }

    validateForm() {
        const { newPassword, confirmPassword } = this.state;
        let pwlen = newPassword.length > 7;
        let lowercase = newPassword.search(/[a-z]/) > -1;
        let uppercase = newPassword.search(/[A-Z]/) > -1;
        let number = newPassword.search(/[0-9]/) > -1;
        let special = newPassword.search(/[^0-9a-zA-Z]/) > -1;

        if (newPassword !== confirmPassword) {
            this.setState({ errorMessage: 'Passwords do not match.' });
            return false;
        } else if (!pwlen) {
            this.setState({
                errorMessage: 'Password needs to be at least 8 characters long',
                isbusy: false,
            });
            return false;
        } else if (lowercase) {
            this.setState({
                errorMessage: 'Password needs a lowercase character',
                isbusy: false,
            });
            return false;
        } else if (uppercase) {
            this.setState({
                errorMessage: 'Password needs an uppercase character',
                isbusy: false,
            });
            return false;
        } else if (number) {
            this.setState({
                errorMessage: 'Password needs a number',
                isbusy: false,
            });
            return false;
        } else if (!special) {
            this.setState({
                errorMessage:
                    'Password needs a special character (!@#$%^&*()_+=-`~/?.>,<;:\'"[{]}|\\)',
                isbusy: false,
            });
            return false;
        }

        return true;
    }

    onFormSubmit(event) {
        event.preventDefault();

        this.setState({ errorMessage: null, isbusy: true }, () => {
            const isValid = this.validateForm();
            if (!isValid) {
                this.setState({ isbusy: false });
                return;
            }
            AuthApi.changePassword(
                this.state.oldPassword,
                this.state.newPassword
            )
                .then(() => {
                    this.setState({ errorMessage: null, isbusy: false });
                    history.push('/user/account');
                })
                .catch(errorMessage => {
                    this.setState({
                        errorMessage: errorMessage,
                        isbusy: false,
                    });
                });
        });
    }

    render() {
        return (
            <form onSubmit={this.onFormSubmit}>
                <div className="form__field">
                    <label htmlFor="oldPassword">Old Password</label>
                    <input
                        type="password"
                        name="oldPassword"
                        placeholder="Old Password"
                        value={this.state.oldPassword}
                        onChange={this.onChange}
                    />
                </div>

                <div className="form__field">
                    <label htmlFor="newPassword">New Password</label>
                    <input
                        type="password"
                        name="newPassword"
                        placeholder="New Password"
                        value={this.state.newPassword}
                        onChange={this.onChange}
                    />
                </div>

                <div className="form__field">
                    <label htmlFor="confirmPassword">
                        Confirm New Password:
                    </label>
                    <input
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm New Password"
                        value={this.state.confirmPassword}
                        onChange={this.onChange}
                    />
                </div>

                <div className="form__buttons">
                    <Button
                        type="submit"
                        defaultText="Change Password"
                        busyText="Changing Password"
                        isbusy={this.state.isbusy}
                    />
                </div>

                <div className="form__field">
                    * Password Requirements:
                    <ul>
                        <li>
                            8 characters comprised of at least:{' '}
                            <i
                                className={
                                    !this.state.pwlen
                                        ? ''
                                        : 'fa fa-check-circle'
                                }
                            />
                        </li>
                        <li>
                            1 upper-case character{' '}
                            <i
                                className={
                                    !this.state.uppercase
                                        ? ''
                                        : 'fa fa-check-circle'
                                }
                            />
                        </li>
                        <li>
                            1 lower-case character{' '}
                            <i
                                className={
                                    !this.state.lowercase
                                        ? ''
                                        : 'fa fa-check-circle'
                                }
                            />
                        </li>
                        <li>
                            1 number{' '}
                            <i
                                className={
                                    !this.state.number
                                        ? ''
                                        : 'fa fa-check-circle'
                                }
                            />
                        </li>
                        <li>
                            1 special character{' '}
                            <i
                                className={
                                    !this.state.special
                                        ? ''
                                        : 'fa fa-check-circle'
                                }
                            />
                        </li>
                    </ul>
                </div>

                <div className="form__footer">
                    <Message error={this.state.errorMessage} />
                </div>
            </form>
        );
    }
}

export default ChangePasswordForm;
